// import axios from "axios";
// import  * as siteConfig from '../config';

// const API = axios.create({
//     baseURL: siteConfig.default.apiBaseURL,
//     timeout: siteConfig.default.apiTimeout,
//     xsrfHeaderName: "X-CSRFToken",
//     xsrfCookieName: "csrftoken",
//     credentials: true,
// })

// API.interceptors.request.use(
//     (config) => {
//         return config;
//     },
//     (error) => {
//         Promise.reject(error)
//     }
// );

// API.interceptors.response.use(
//     (response) => {
//         return response;
//     },
//     (error) => {
//         Promise.reject(error)
//     }
// );

// export default API;


import axios from "axios";
import * as siteConfig from '../config';

const API = axios.create({
    baseURL: siteConfig.default.apiBaseURL,
    timeout: siteConfig.default.apiTimeout,
    xsrfHeaderName: "X-CSRFToken",
    xsrfCookieName: "csrftoken",
    credentials: true,
})

API.interceptors.request.use(
    (config) => {
        // ─── Auto-attach division_id to every request ───
        const stored = localStorage.getItem("selectedDivision");
        if (stored) {
            try {
                const division = JSON.parse(stored);
                if (division?.division_id) {
                    // Attach as query parameter automatically
                    config.params = {
                        ...config.params,        // keep any existing params
                        division_id: division.division_id,
                    };
                }
            } catch (e) {
                console.error("Failed to parse selectedDivision:", e);
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);  // ← added return (was missing)
    }
);

API.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);  // ← added return (was missing)
    }
);

export default API;